import { TextLink, Text} from 'glic-ui-components'

const ImpContact = () => {
   
    const gotoLink = (evt) => {
        evt.preventDefault();
        window.open(evt.target.id,
            "_blank", "width=900, height=600");
        return false;
    }
    return (
        <>
            <div className='row'>
                <div className='col-12'>
                    <h2 className="formLabel text-header"
                        color="HudsonNavy" >
                        Important Contact Information
                    </h2>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <Text bodyMd>
                        Managed Dental Care Customer Service:<br />
                        <ul>
                            <li>1-800-273-3330</li>
                        </ul>
                    </Text>
                    <Text bodyMd>
                        California Department of Managed Health Care:<br />
                        <ul>
                            <li>1-800-466-2219</li>
                            <li>1-877-688-9891 (TDD)</li>
                            <li>
                                <TextLink
                                    inlineSize="body-sm"
                                    id="https://www.dmhc.ca.gov/"
                                    onClick={gotoLink} aria-labelledby="CaliforniaLink">
                                    www.dmhc.ca.gov
                                </TextLink>
                                <span id="CaliforniaLink" class="visually-hidden">
                                    California Department of Managed Health Care opens in new window
                                </span>
                            </li>
                        </ul>
                    </Text>
                </div>
            </div>

           
        </>
    )
}

export default ImpContact
